module.exports = __webpack_public_path__ + "img/start-1.dfdfc44.png";